import { useNavigation } from '@react-navigation/core';
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Screens } from '../../../constants/ScreenNames';
import { CommonProperties } from '../../../styles';
import BottomButton from '../../BottomButton';
import WrapBottomColor from '../../containers/WrapBottomColor';
import SwitchWithLabel from '../../SwitchWithLabel';

const InvitePermissionsModal = () => {
  const navigation = useNavigation();
  const [mayInvite, setMayInvite] = useState(false);
  const [maySchedule, setMaySchedule] = useState(false);

  return (
    <WrapBottomColor>
      <View style={styles.container}>
        <SwitchWithLabel
          left
          label="Invited may invite others"
          value={mayInvite}
          onPress={() => setMayInvite(!mayInvite)}
        />
        <SwitchWithLabel
          left
          label="Invited may add to schedule"
          value={maySchedule}
          onPress={() => setMaySchedule(!maySchedule)}
        />
      </View>
      <BottomButton label="Apply" full onPress={() => navigation.navigate(Screens.TripHub)} />
    </WrapBottomColor>
  );
};

export default InvitePermissionsModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...CommonProperties.p3,
  },
});
